import { query } from "./strapi";
import apiCache from './apiCache';

interface NavLink {
  id: number;
  name: string;
  url: string;
  __component?: string;
}

export async function getNavBarLinks() {
  const CACHE_KEY = 'navbar-desktop-link';
  const TWO_HOURS = 2 * 60 * 60 * 1000; // 2 hours in milliseconds
  
  // Check cache first
  const cachedData = apiCache.get<NavLink[]>(CACHE_KEY);
  if (cachedData) {
    return cachedData;
  }

  try {
    const responseData = await query("navbar-desktop-link");

    let navLinks: NavLink[] = [];

    // If the response contains a data property with an array, use that array
    if (responseData && responseData.data && Array.isArray(responseData.data)) {
      navLinks = responseData.data;
    }
    // If the response is an array, use it directly
    else if (Array.isArray(responseData)) {
      navLinks = responseData;
    }
    else {
      console.error("Unexpected response format:", responseData);
      return [];
    }

    // Store in cache with 2-hour expiration
    apiCache.set(CACHE_KEY, navLinks, TWO_HOURS);
    
    return navLinks;
  } catch (error) {
    console.error("Error fetching navbar links:", error);
    throw error;
  }
}

// Function to refresh navbar links data
export function refreshNavBarLinks() {
  apiCache.clear('navbar-desktop-link');
  return getNavBarLinks(); // Re-fetch from API
}
